import { setUser } from "@sentry/react";
import { create, StateCreator } from "zustand";
import { devtools, persist } from "zustand/middleware";

import { queryClient } from "@/libs/react-query";
import { AdminSignInData } from "@/service/response/admin-auth";
import { AdminUserRole } from "@/modules/common/types/Users.enum";

interface Session {
  accessToken: string;
  refreshToken: string;
  user: AdminSignInData;
}

interface SessionStore {
  session: Session | null;
  setSession: (session: Session) => void;
  clearSession: () => void;
  canUserSee: (minimumUserRole: AdminUserRole) => boolean;
}

const middleware = (f: StateCreator<SessionStore, [], []>) => devtools(persist(f, { name: "admin-session" }));

export const useSessionStore = create<SessionStore>()(
  middleware((set, get) => ({
    session: null,
    setSession: (session: Session) => {
      set({ session });
      setUser({ id: session.user.id.toString(), email: session.user.email });
    },
    clearSession: () => {
      queryClient.clear();
      setUser(null);
      set({ session: null });
    },
    canUserSee: (minimumUserRole: AdminUserRole) => {
      const user = get().session?.user;

      return user ? user.role >= minimumUserRole : false;
    },
  })),
);
